import { Dtos, IncomeStatementId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { financialPeriodsQueryKey, incomeStatementsQueryKey } from "../../financials";

export function useAdminPromoteIncomeStatement(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (incomeStatementId: IncomeStatementId) =>
			post<Dtos.Admin.IncomeStatement.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/income-statements/${incomeStatementId}/promote`,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});

	return {
		promoteIncomeStatement: mutation.mutate,
		promoteISLoading: mutation.isPending,
		promoteISError: mutation.error,
		resetPromoteISError: mutation.reset,
	};
}
